import { queryOptions, useQuery } from '@tanstack/react-query'
import { apiClient } from '~/lib/api-client'
import { CACHE_CONFIG } from '~/lib/cache-config'

export async function fetchRegionGuide(regionId: string, lang: string) {
  // @ts-ignore: Hono client type inference issue with nested param paths
  const res = await apiClient.regions[':id'].guide.$get({
    param: { id: regionId },
    query: { lang },
  })
  if (!res.ok) {
    if (res.status === 404) return null
    throw new Error(`Failed to fetch region guide ${regionId}: ${res.status}`)
  }
  return res.json()
}

export function regionGuideQueryOptions(regionId: string, lang: string) {
  return queryOptions({
    queryKey: ['region-guide', regionId, lang],
    queryFn: () => fetchRegionGuide(regionId, lang),
    staleTime: CACHE_CONFIG.reference.staleTime,
    gcTime: CACHE_CONFIG.reference.gcTime,
    enabled: !!regionId,
  })
}

export function useRegionGuide(regionId: string, lang: string) {
  return useQuery(regionGuideQueryOptions(regionId, lang))
}
